export { DocumentService } from './document.service'
export { CampaignService } from './campaign.service'


// WEBPACK FOOTER //
// ./src/app/client-core/services/index.ts